import { useCallback, useContext, useEffect, useState } from 'react';

import { NotificationContext, UserContext } from '../../App';
import { updateName } from '../../requests/requests';
import { ButtonType, SnackbarType } from '../../types/enums';
import Button from '../Button/Button';
import Input from '../Input/Input';

const UpdateName = () => {
  const notify = useContext(NotificationContext);
  const { user, setUser } = useContext(UserContext);
  const [name, setName] = useState(user?.name ?? '');

  useEffect(() => {
    if (user?.name) {
      setName(user.name);
    }
  }, [user]);

  const onSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      if (name !== user?.name && name.length > 2) {
        updateName(name).then(
          ({ data }) => {
            setUser(data.user);
            notify('Your name has been updated!', SnackbarType.SUCCESS);
          },
          () => {
            notify('Could not update your name, please reach out to us!', SnackbarType.ERROR);
          }
        );
      }
    },
    [name, user]
  );

  return (
    <div>
      <p>
        <strong>
          Your E mail address: <span className="color-orange">{user?.email}</span>
        </strong>
      </p>
      <form onSubmit={onSubmit} style={{ marginBottom: '2.25rem' }}>
        <Input
          id="name"
          label="Your Name:"
          setValue={setName}
          value={name}
          placeholder="Your Name"
          error={name.length < 2 ? 'Minimum 2 characters required.' : ''}
        />
        <Button type={ButtonType.PRIMARY} isSubmit>
          SAVE NAME
        </Button>
      </form>
    </div>
  );
};

export default UpdateName;
